<template>
  <div v-if="modalShowData" class="modal" :class="modalShowData ? 'text-xl' : 'text-4xl'">
    <!-- Modal content -->
    <div :class="parentModalClass">
      <UiOnClickOutside :do="closeClick">
        <div
          class="modal-content modal-animate-top bg-primary-white rounded-3xl overflow-auto ml-auto mb-2.5 mr-auto mt-16.5 table relative inset-0"
          :class="[modalClasses, { centered: !disablePositionCenter }]"
          :style="modalStyle"
        >
          <header
            v-if="$slots.header"
            class="modal-content__header flex justify-between items-center p-7.5 text-3xl rounded-t-xl h-20 border-b border-primary-grey text-primary-purple-600"
            :class="[headerClasses]"
          >
            <slot name="header" />
            <slot name="closeBtn">
              <div v-if="showClose" class="close-btn cursor-pointer text-2xl" @click="closeClick">
                &times;
              </div>
            </slot>
          </header>
          <div class="modal-content__body" :class="bodyClasses">
            <slot />
          </div>
          <div
            v-if="$slots.footer"
            :class="[footerClasses]"
            class="modal-content__footer border-t border-primary-grey flex-row flex p-4"
          >
            <slot name="footer" />
          </div>
        </div>
      </UiOnClickOutside>
    </div>
  </div>
</template>

<script>
import UiOnClickOutside from '@src/components/misc/UiOnClickOutside.vue'
export default {
  name: 'UiModalContainer',
  components: {
    UiOnClickOutside,
  },
  props: {
    parentModalClass: {
      type: String,
      default: '',
    },
    preventOutSideClose: {
      type: Boolean,
      default: false,
    },
    disablePositionCenter: {
      type: Boolean,
      default: false,
    },
    modalClasses: {
      type: [Object, String],
      description: 'Modal dialog css classes',
      default: '',
    },
    headerClasses: {
      type: [Object, String],
      description: 'Modal Header css classes',
      default: '',
    },
    bodyClasses: {
      type: [Object, String],
      description: 'Modal Body css classes',
      default: '',
    },
    footerClasses: {
      type: [Object, String],
      description: 'Modal Footer css classes',
      default: '',
    },
    modalShow: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    modalWidth: {
      type: Number,
      default: 50,
    },
    actionName: {
      type: String,
      default: 'save',
    },
    confirmEventName: {
      type: String,
      default: '',
    },
    modalHeader: {
      type: Boolean,
      default: false,
    },
    loadingActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalShowData: false,
    }
  },
  computed: {
    modalStyle() {
      return {
        width: `${this.modalWidth}%`,
      }
    },
  },
  watch: {
    modalShow: {
      deep: true,
      immediate: true,
      handler(newmodalShow) {
        if (newmodalShow) {
          document.body.style.overflowY = 'hidden'
          this.modalShowData = true
          //   this.$store.commit('layout/IS_MODAL_OPEN', true)
        } else {
          document.body.style.overflowY = 'auto'
          this.modalShowData = false

          //   this.$store.commit('layout/IS_MODAL_OPEN', false)
        }
      },
    },
  },

  methods: {
    /**
     * handle click outside the component
     */
    handleClickOutside() {
      if (!this.preventOutSideClose) {
        this.cancelClick()
      }
    },
    /**
     * handle the cancel click
     * emit the cancel event to parent component
     */
    cancelClick() {
      if (!this.loadingActions) {
        this.$emit('handleClick', 'cancel')
      }
    },
    /**
     * handle the close click
     * emit the close event to parent component
     */
    closeClick() {
      this.$emit('handleClick', 'close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@src/design/_mediaquery-mixin.scss';
.loader {
  width: 1.125em;
  height: 1.125em;
  margin: auto;
  border: 2px solid var(primary-green-bglight);
  border-top: 2px solid var(--primary-green);
  border-radius: 50%;
  animation: spin 0.3s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.modal-content {
  max-height: 100vh;
  overflow: auto;
  @include media(null, 1024px) {
    width: 60% !important;
  }
  @include media(null, 768px) {
    width: 80% !important;
    //margin: auto;
  }
  @include media(null, 640px) {
    width: 90% !important;
  }
}
.width-full {
  @media only screen and (max-width: 1024px) {
    width: 100% !important;
  }
}
</style>

<style lang="scss">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
}

/* Modal Content/Box */

.modal-content {
  width: 50%;
  @media screen and (max-width: 550px) {
    &.centered {
      margin-bottom: 25%;
    }
  }
  @media (min-width: 550px) and (max-width: 960px) {
    &.centered {
      margin-bottom: 2%;
    }
  }
}
.modal-animate-top {
  animation: animatetop 0.4s;
}

@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }

  to {
    top: 0;
    opacity: 1;
  }
}
</style>